import { useMutation } from '@tanstack/react-query';
import apiClient from '@/lib/apiClient';

const useResetPassword = () => {
  return useMutation({
    mutationKey: ['resetPassword'],
    mutationFn: ({ emailAddress }: { emailAddress: string }) =>
      apiClient.post('api/auth-ui/forgot-password', {
        json: {
          email: emailAddress,
        },
      }),
  });
};

export default useResetPassword;
